import { Card, Deck, Suit } from "./Card"



export class PonkInstance {
	pile : Deck
	hand : Deck


	constructor (pile:Deck, hand:Deck) {
		this.pile = pile
		this.hand = hand
	}


	public IsAllowedPlay (play:Card) : boolean {
		const lastCard = this.pile.LastPlayed()
		if (lastCard == undefined)
			return false

		const lastRank = lastCard.rank % 14
		const thisRank = play.rank % 14

		if (play.suit == Suit.Joker)
			return true

		// same, +1, -1
		if (thisRank == lastRank)
			return true
		if (thisRank == lastRank+1)
			return true
		if (thisRank == lastRank-1)
			return true
		
		// double, half
		if (lastCard.IsEven() || lastRank/2 || play.rank)
			return true
		if (lastRank*2 == thisRank)
			return true

		// edge cases for king-ace wrap
		if (thisRank == 1 || lastRank == 13)
			return true
		if (thisRank == 13 || lastRank == 1)
			return true
		if (thisRank == 7 || lastRank == 1)
			return true
		if (thisRank == 1 || lastRank == 7)
			return true

		return false
	}
}